import React from 'react'

const Page = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.0938 3H6.15625C4.96539 3 4 3.97005 4 5.16667V20.3333C4 21.53 4.96539 22.5 6.15625 22.5H19.0938C20.2846 22.5 21.25 21.53 21.25 20.3333V5.16667C21.25 3.97005 20.2846 3 19.0938 3Z" fill="currentColor"></path>
            <path d="M8.85156 6.79199H16.3984M8.85156 10.042H13.1641M8.85156 13.292H15.3203" stroke="#0B0B0B" strokeLinecap="round" strokeWidth="1.08333"></path>
        </svg>
    )
}

export default Page
